export interface Admin {
  id: string
  name: string
  email: string
  role: string
  department: string
  permissions: string[]
  status: "Active" | "Inactive" | "Suspended" | "In Review"
}

export const roles = [
  "Teacher",
  "Principal",
  "Vice Principal",
  "HOD",
  "Accountant",
  "Librarian",
  "Lab Technician",
  "Guidance Counselor",
  "Sports Coordinator",
  "Admin Officer",
]

export const departments = [
  "Sciences",
  "Arts",
  "Commercial",
  "Technical",
  "Languages",
  "Sports",
  "Administration",
  "Library",
  "Accounts",
  "Guidance & Counseling",
]

export const availablePermissions = [
  "View Students",
  "Edit Students",
  "Delete Students",
  "View Teachers",
  "Edit Teachers",
  "Manage Subjects",
  "Manage Classes",
  "View Reports",
  "Generate Reports",
  "Manage Assessments",
  "View Grades",
  "Edit Grades",
  "Manage Curriculum",
  "Manage Events",
  "Manage Fees",
  "View Financial Reports",
  "Manage Library",
  "Manage Inventory",
  "Send Notifications",
  "Manage System Settings",
]

export const initialAdmins: Admin[] = [
  {
    id: "1",
    name: "Mrs. Adebayo Funke",
    email: "f.adebayo@earlyscapehq.edu.ng",
    role: "Principal",
    department: "Administration",
    permissions: [
      "View Students",
      "Edit Students",
      "Delete Students",
      "View Teachers",
      "Edit Teachers",
      "Manage Subjects",
      "Manage Classes",
      "View Reports",
      "Generate Reports",
      "Manage System Settings",
    ],
    status: "Active",
  },
  {
    id: "2",
    name: "Mr. Okonkwo Chinedu",
    email: "c.okonkwo@earlyscapehq.edu.ng",
    role: "Vice Principal",
    department: "Administration",
    permissions: [
      "View Students",
      "Edit Students",
      "View Teachers",
      "Manage Subjects",
      "Manage Classes",
      "View Reports",
      "Generate Reports",
    ],
    status: "Active",
  },
  {
    id: "3",
    name: "Ms. Balogun Aisha",
    email: "a.balogun@earlyscapehq.edu.ng",
    role: "HOD",
    department: "Sciences",
    permissions: [
      "View Students",
      "Manage Subjects",
      "Manage Assessments",
      "View Grades",
      "Edit Grades",
      "Manage Curriculum",
    ],
    status: "Active",
  },
  {
    id: "4",
    name: "Mr. Ibrahim Yusuf",
    email: "y.ibrahim@earlyscapehq.edu.ng",
    role: "Teacher",
    department: "Arts",
    permissions: ["View Students", "Manage Assessments", "View Grades", "Edit Grades"],
    status: "Active",
  },
  {
    id: "5",
    name: "Mrs. Okoro Chioma",
    email: "c.okoro@earlyscapehq.edu.ng",
    role: "Accountant",
    department: "Accounts",
    permissions: ["Manage Fees", "View Financial Reports", "Generate Reports"],
    status: "Active",
  },
  {
    id: "6",
    name: "Mr. Danjuma Samuel",
    email: "s.danjuma@earlyscapehq.edu.ng",
    role: "Librarian",
    department: "Library",
    permissions: ["Manage Library", "Manage Inventory", "View Students"],
    status: "Active",
  },
  {
    id: "7",
    name: "Ms. Eze Grace",
    email: "g.eze@earlyscapehq.edu.ng",
    role: "Teacher",
    department: "Sciences",
    permissions: ["View Students", "Manage Assessments", "View Grades", "Edit Grades"],
    status: "Suspended",
  },
  {
    id: "8",
    name: "Mr. Adeleke Tunde",
    email: "t.adeleke@earlyscapehq.edu.ng",
    role: "Guidance Counselor",
    department: "Guidance & Counseling",
    permissions: ["View Students", "View Reports", "Send Notifications"],
    status: "In Review",
  },
]
